<template>
    <v-dialog v-model="display" max-width="600">
        <v-card>
            <v-icon data-cy="close-modal" class="v-card-close" @click="display = false">mdi-close</v-icon>
            <v-card-title v-html="title" />
            <v-card-text class="text-center" v-html="text" />
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {EventBus, SHOW_PREFERENCES_MODAL} from '@/utils/event-bus'

    @Component
    export class PreferencesModal extends Vue {
        display: boolean = false
        title: string = null
        text: string = null

        mounted() {
            EventBus.$on(SHOW_PREFERENCES_MODAL, this.show)
        }

        beforeUnmount() {
            EventBus.$off(SHOW_PREFERENCES_MODAL, this.show)
        }

        show({title, text}): void {
            this.title = title
            this.text = text
            this.display = true
        }
    }

    export default PreferencesModal
</script>
